import ApiService2 from "./shared/ApiService2";

export default {
  logar: async usuarioAutenticacao =>
    ApiService2.post("/api/autenticacao/login", usuarioAutenticacao)
};
